import Vue from "vue";
import VueRouter, { RouteConfig, Route } from "vue-router";
import auth from "@/services/auth";
import configuration from "@/models/Configuration";

// #region - Components
import LoginPage from "@/modules/login/views/Login.vue";
import Home from "@/views/Home.vue";
import SettingsPage from "@/views/Settings/SettingsPage.vue";
import ChangePasswordPage from "@/views/Settings/Pages/ChangePasswordPage.vue";

import BanksPage from "@/modules/bank/views/BanksPage.vue";
import BankPage from "@/modules/bank/views/BankPage.vue";

import InvoiceTypesPage from "@/modules/invoiceType/views/InvoiceTypesPage.vue";
import InvoiceTypePage from "@/modules/invoiceType/views/InvoiceTypePage.vue";

import AccountActionSourcesPage from "@/modules/accountActionSource/views/AccountActionSourcesPage.vue";
import AccountActionSourcePage from "@/modules/accountActionSource/views/AccountActionSourcePage.vue";

import AccountTypePage from "@/modules/accountType/views/AccountTypePage.vue";
import AccountTypesPage from "@/modules/accountType/views/AccountTypesPage.vue";
import CashPointsPage from "@/modules/cashPoint/views/CashPointsPage.vue";
import CashPointPage from "@/modules/cashPoint/views/CashPointPage.vue";

import InvoiceGroupsPage from "@/modules/invoiceGroup/views/InvoiceGroupsPage.vue";
import InvoiceGroupPage from "@/modules/invoiceGroup/views/InvoiceGroupPage.vue";

import PaymentModesPage from "@/modules/paymentMode/views/PaymentModesPage.vue";
import PaymentModePage from "@/modules/paymentMode/views/PaymentModePage.vue";

import AccItemParamsPage from "@/modules/accItemParam/views/AccItemParamsPage.vue";

import PartnerDetailsPage from "@/modules/partner/views/PartnerDetailsPage.vue";
import PartnerEditPage from "@/modules/partner/views/PartnerEditPage.vue";
import PartnerPage from "@/modules/partner/views/PartnerPage.vue";
import PartBankCreatePage from "@/modules/partner/views/PartBankCreatePage.vue";
import PartSupplierCreatePage from "@/modules/partner/views/PartSupplierCreatePage.vue";
import PartCustCreatePage from "@/modules/partner/views/PartCustCreatePage.vue";
import PartPersonCreatePage from "@/modules/partner/views/PartPersonEditor.vue";
import PartnerMatchingPage from "@/modules/partner/views/PartnerMatchingPage.vue";
import DocumentBrowser from "@/modules/document/views/DocumentBrowser.vue";
import DocumentCreatePage from "@/modules/document/views/DocumentCreatePage.vue";

import NoticesPage from "@/modules/notice/views/NoticesPage.vue";
import NoticePage from "@/modules/notice/views/NoticePage.vue";
import NoticePartnerPage from "@/modules/notice/views/PartnerSearch.vue";

import OutgoingInvoiceTypeEditModelsPage from "@/modules/outgoingInvoiceType/views/OutgoingInvoiceTypeEditModelsPage.vue";
import OutgoingInvoiceTypeEditModelPage from "@/modules/outgoingInvoiceType/views/OutgoingInvoiceTypeEditModelPage.vue";

import GeneralIngoingInvoicesPage from "@/modules/generalIngoingInvoice/views/GeneralIngoingInvoicesPage.vue";
import GeneralIngoingInvoicePartnerSearch from "@/modules/generalIngoingInvoice/views/PartnerEditorView.vue";
import InvoiceFlowPage from "@/modules/invoiceFlow/views/InvoiceFlowPage.vue";
import InvoiceFlowSettingsPage from "@/modules/invoiceFlow/views/InvoiceFlowSettingsPage.vue";
import ApprovalMatrixPage from "@/modules/approvalMatrix/views/ApprovalMatrixPage.vue";
import InvoiceEditAfterVatConfession from "@/modules/invoiceFlow/views/InvoiceEditVatConfession.vue"

import InvoiceBrowser from "@/modules/invoiceBrowser/InvoiceBrowser.vue";
import TechnicalInvoiceBrowser from "@/modules/technicalInvoice/views/TechnicalInvoiceBrowser.vue";

import CurrencyRatesPage from "@/modules/currencyRate/views/CurrencyRatesPage.vue";
import CurrencyRatePage from "@/modules/currencyRate/views/CurrencyRatePage.vue";

import IncomingInvoiceTypesPage from "@/modules/incomingInvoice/views/IncomingInvoiceTypesPage.vue";
import IncomingInvoiceTypePage from "@/modules/incomingInvoice/views/IncomingInvoiceTypePage.vue";

import AccountVoucherTypesPage from "@/modules/accountVoucherType/views/AccountVoucherTypesPage.vue";
import AccountVoucherTypePage from "@/modules/accountVoucherType/views/AccountVoucherTypePage.vue";

import CashStatementsApiSearchPage from "@/modules/cashStatement/views/CashStatementsApiSearchPage.vue";
import CashStatementPage from "@/modules/cashStatement/views/CashStatementPage.vue";
import CashDocumentPage from "@/modules/cashStatement/views/CashDocumentPage.vue";
import CashStatementCashPointSearch from "@/modules/cashStatement/components/CashPointSearch.vue";
import VIRIItemPage from "@/modules/cashStatement/viriItems/views/VIRIItemPage.vue";

import BankStatementCreatePage from "@/modules/bankStatement/views/BankStatementCreatePage.vue";
import BankStatementsApiSearchPage from "@/modules/bankStatement/views/BankStatementsApiSearchPage.vue";
import BankPreAccStatementsView from "@/modules/bankPreAccounting/views/BankPreAccStatementsView.vue";
import BankPreAccEditorView from "@/modules/bankPreAccounting/views/BankPreAccEditorView.vue";
import CashPreAccStatementsView from "@/modules/cashPreAccounting/views/CashPreAccStatementsView.vue";
import CashPreAccEditorView from "@/modules/cashPreAccounting/views/CashPreAccEditorView.vue";
import StoreInOutPreAccDocsView from "@/modules/storeInOutPreAccounting/views/StoreInOutPreAccDocsView.vue";
import CurrentAccountPreAccActionsView from "@/modules/currentAccountPreAccounting/views/CurrentAccountPreAccActionsView.vue";

import BankStatementItemsPage from "@/modules/bankStatement/views/BankStatementItemsPage.vue";

import CustomsInvoicePage from "@/modules/customsInvoice/views/CustomsInvoicePage.vue";
import CustomsInvoicesPage from "@/modules/customsInvoice/views/CustomsInvoicesPage.vue";

import AccountCodeEditModelsPage from "@/modules/accountCodeEditModel/views/AccountCodeEditModelsPage.vue";
import AccountCodeEditModelPage from "@/modules/accountCodeEditModel/views/AccountCodeEditModelPage.vue";
import AccountCodeEditList from "./modules/accountCodeEditModel/views/AccountCodeEditList.vue";

import SystemParametersPage from "@/modules/configuration/views/SystemParametersPage.vue";

import IncomingInvoicePage from "@/modules/generalIngoingInvoice/views/IncomingInvoicePage.vue";

import InvoiceFlowTaskPage from "@/modules/invoiceFlowTask/views/InvoiceFlowTaskPage.vue";

import UserAccountNosPage from "@/modules/userAccountNo/views/UserAccountNosPage.vue";
import UserAccountNoPage from "@/modules/userAccountNo/views/UserAccountNoPage.vue";

import Roles from "@/modules/roles/views/Roles.vue";
import TaxesPage from "@/modules/taxes/views/TaxesPage.vue";
import TaxPage from "@/modules/taxes/views/TaxPage.vue";

import DownPaymentsPage from "@/modules/downPayment/views/DownPaymentsPage.vue";
import DownPaymentSearchPage from "@/modules/downPayment/views/DownPaymentSearchPage.vue";
import DownPaymentRequestPage from "@/modules/downPayment/views/DownPaymentRequestPage.vue";

import GeneralLedgerPeriods from "@/modules/generalLedger/views/Periods.vue";
import GeneralLedgerTransactionGrid from "@/modules/generalLedger/views/GeneralLedgerTransactionsGrid.vue";
import GeneralLedgerNotActivatedInvests from "@/modules/generalLedger/notActivatedInvests/views/NotActivatedInvests.vue";

import DebitPaymentView from "@/modules/debitPayment/views/DebitPaymentView.vue";
import DebitPaymentEditPage from "@/modules/debitPayment/views/DebitPaymentEditPage.vue";
import DebitPaymentSearchPage from "@/modules/debitPayment/views/DebitPaymentSearchPage.vue";

import ActionLogPage from "@/modules/actionLog/views/ActionLogPage.vue";
import DimCodeTypesPage from "@/modules/dimCodeType/views/DimCodeTypesPage.vue";

import InvoiceParameterPage from "@/modules/invoiceParametering/views/invoiceParamGrid.vue";
import InvoiceParameterEditPage from "@/modules/invoiceParametering/views/invoiceParamEdit.vue";

import InvoiceDeadlinesPage from "@/modules/invoicePaymentSchedule/views/InvoiceDeadlinesPage.vue";

import UninvoicedStockCorrectionsPage from "@/modules/uninvoicedStockCorrection/views/UninvoicedStockCorrectionsPage.vue";
import UninvoicedStockCorrectionSearchPage from "@/modules/uninvoicedStockCorrection/views/UninvoicedStockCorrectionSearchPage.vue";
import UninvoicedStockCorrectionEditPage from "@/modules/uninvoicedStockCorrection/views/UninvoicedStockCorrectionEditPage.vue";

import BankRemitsPage from "@/modules/bankRemit/views/BankRemitsPage.vue";
import BankRemitCreatePage from "@/modules/bankRemit/views/BankRemitCreatePage.vue";
import BankRemitHeadView from "@/modules/bankRemit/views/BankRemitHeadView.vue";
import BankRemitItemView from "@/modules/bankRemit/views/BankRemitItemView.vue";
import BankRemitApprovalView from "@/modules/bankRemit/views/BankRemitApprovalView.vue";
import BankSelectView from "@/modules/bankRemit/views/BankSelectView.vue";
import BankRemitForwardingView from "@/modules/bankRemit/views/BankRemitForwardingView.vue";

import InvoiceAccounting from "./modules/invoiceFlow/views/InvoiceAccounting.vue";

import BankExtractImportsPage from "@/modules/bankExtract/views/BankExtractImportsPage.vue";
import BankExtractImportEditPage from "@/modules/bankExtract/views/BankExtractImportEditPage.vue";
import BankExtractImportCreatePage from "@/modules/bankExtract/views/BankExtractImportCreatePage.vue";

// #region reports
import ReportsPage from "@/modules/reports/views/ReportsPage.vue";
import PowerBIPage from "@/modules/powerBI/views/PowerBIPage.vue";
import BankTransferNotifyReportPage from "@/modules/reports/BankTransferNotify/views/BankTransferNotifyReportPage.vue";
import BankTransferRemitReportPage from "@/modules/reports/BankTransferRemit/views/BankTransferRemitReportPage.vue";
import ParameterizedAccountReport from "@/modules/reports/Account/ParameterizedAccountReport.vue"
import NotoReports from "@/modules/reports/Account/NotoReports.vue"
// #endregion

import BankExtractImportAccountTypeEdit from "@/modules/bankExtractImportAccountType/views/BankExtractImportAccountTypeEdit.vue";

import FixAssetGroupsPage from "@/modules/fixAssetGroup/views/FixAssetGroupsPage.vue";
import FixAssetGroupPage from "@/modules/fixAssetGroup/views/FixAssetGroupPage.vue";

import FullfilmentTolerancesPage from "@/modules/generalIngoingInvoice/views/FullfilmentTolerancesPage.vue";

import InvoiceMigrationPage from "@/modules/invoiceMigration/views/InvoiceMigrationPage.vue";
import BankStatementFlowPage from "@/modules/bankStatement/views/BankStatementFlowPage.vue";
import StockFinancingImportPage from "@/modules/bankStatement/views/StockFinancingImportPage.vue";
import BankStatementApprovalPage from "@/modules/bankStatement/views/BankStatementApprovalPage.vue";
import CreditCardsPage from "@/modules/creditCard/views/CreditCardsPage.vue";
import CreditCardPage from "@/modules/creditCard/views/CreditCardPage.vue";

//Pc kód karbantartó
import PcCodeView from "@/modules/pcCode/views/PcCodeView.vue";

import LettersOfCreditPage from "@/modules/letterOfCredit/LettersOfCreditPage.vue";
import LetterOfCreditPage from "@/modules/letterOfCredit/LetterOfCreditPage.vue";

import InvoiceGroupApprovalsPage from "@/modules/invoiceGroupApproval/views/InvoiceGroupApprovalsPage.vue";

import AccComplaintsTable from "@/modules/accComplaints/views/AccComplaintsTable.vue";

import CurrentAccountPage from "@/modules/currentAccount/CurrentAccountsPage.vue";
import CurrentAccountArrangementPage from "@/modules/currentAccount/CurrentAccountArrangementPage.vue";
import WriteOffDebtPage from "@/modules/writeOffDebt/WriteOffDebtPage.vue";
import WriteOffDebtInvoicesPage from "@/modules/writeOffDebt/WriteOffDebtInvoicesPage.vue";
import WriteOffPage from "@/modules/writeOffDebt/WriteOffPage.vue";
// #endregion

import ProformToInvoiceView from "@/modules/generalOutgoingInvoice/proformToFinal/views/ProformToInvoiceView.vue";
import GeneralOutgoingInvoiceLayout from "@/modules/generalOutgoingInvoice/views/GeneralOutgoingInvoiceLayout.vue";
import PayOpenInvoicesView from "@/modules/generalOutgoingInvoice/openInvoices/views/PayOpenInvoicesView.vue";
import VIRIPage from "@/modules/cashStatement/viriItems/views/VIRIPage.vue";

import OpenPayoffDownpaymentsView from "@/modules/cashPoint/openPayoffDownpayments/views/OpenPayoffDownpaymentsView.vue";
import InvoiceLedgerSubmissionView from "@/modules/generalLedger/invoiceSubmission/views/InvoiceLedgerSubmissionView.vue";
import InvoiceImportPage from "@/modules/generalIngoingInvoice/views/InvoiceImportPage.vue"
import InvoiceItemsImportPage from "@/modules/generalIngoingInvoice/views/InvoiceItemsImportPage.vue"
import InvoiceImportViewPage from "@/modules/generalIngoingInvoice/views/InvoiceImportViewPage.vue"

import StornoSummaryBrowser from "@/modules/stornoSummary/views/StornoSummaryBrowser.vue";
import OverSummaryBrowser from "@/modules/overSummary/views/OverSummaryBrowser.vue";
import OverSummaryView from "@/modules/overSummary/views/OverSummaryView.vue";
import CaroStornoPage from "@/modules/caroStorno/views/CaroStornoPage.vue";

import Transactions from "@/modules/transactions/views/Transactions.vue";
import TransactionsEditPage from "@/modules/transactions/views/TransactionsEditPage.vue";
import PreAccInvoicesView from "@/modules/preAccounting/views/PreAccInvoicesView.vue";
import PreAccEditorView from "@/modules/preAccounting/views/PreAccEditorView.vue";
import PreAccGeniProjectsView from "@/modules/preAccounting/views/PreAccGeniProjectsView.vue";
//Főkönyvi tranzakciók modul
import TransactionsView from "@/modules/transactions/views/TransactionsView.vue";
import TransactionEditor from "@/modules/transactions/views/TransactionEditor.vue";

import KanriInvoicesPage from "@/modules/kanri/views/KanriInvoicesPage.vue";
import GenoExperimentalInvoicePage from "@/modules/kanri/views/GenoExperimentalInvoicePage.vue";
import GenoExperimentalInvoiceEditPage from "@/modules/kanri/views/GenoExperimentalInvoiceEditPage.vue";
import KanriRedirectPage from "@/modules/kanri/views/KanriRedirectPage.vue";
import KanriCarAgreementInvoicesPage from "@/modules/kanri/views/KanriCarAgreementInvoicesPage.vue";

import GpartsListView from "./modules/gpartsEdit/views/GpartsListView.vue";
import GpartEditor from "./modules/gpartsEdit/views/GpartEditor.vue";
import CardPayments from "./modules/generalOutgoingInvoice/openInvoices/CardPayments.vue";

import links from "./models/Links";

import DownloadableInvoices from "@/modules/downloadInvoices/views/DownloadableInvoices.vue";
import GeneralLedgerAuditXml from "./modules/transactions/views/GeneralLedgerAuditXml.vue";
import DimensionListReportView from "./modules/generalLedger/views/DimensionListReportView.vue";
import GeneralLedgerStatementView from "./modules/generalLedger/views/GeneralLedgerStatementView.vue";
import RevaluationView from "./modules/generalLedger/views/RevaluationView.vue";
import GeneralLedgerOpenCloseView from "./modules/generalLedger/views/GeneralLedgerOpenCloseView.vue";
import DimensionTransferView from "./modules/generalLedger/views/DimensionTransferView.vue";
import MonthlyExtractView from "./modules/generalLedger/views/MonthlyExtractView.vue";
import RiportDefinitionView from "./modules/generalLedger/views/RiportDefinitionView.vue";
import RiportDefinitionEditView from "./modules/generalLedger/views/RiportDefinitionEditView.vue";
import BalanceIncomeReportView from "./modules/generalLedger/views/BalanceIncomeReportView.vue";
import BookingEventsReportView from "./modules/generalLedger/views/BookingEventsReportView.vue";
import ParamReportView from "./modules/generalLedger/views/ParamReportView.vue";
import GeneralLedgerReportView from "./modules/generalLedger/views/GeneralLedgerReportView.vue";
import CostMatrixView from "./modules/generalLedger/views/CostMatrixView.vue";
import BookingTemplateView from "./modules/generalLedger/views/BookingTemplateView.vue";
import TransactionImportView from "./modules/generalLedger/views/TransactionImportView.vue";
import PayrollImportView from "./modules/generalLedger/views/PayrollImportView.vue";
import LedgerExportView from "./modules/generalLedger/views/LedgerExportView.vue";
import NovitaxImportView from "./modules/generalLedger/views/NovitaxImportView.vue";
import DimensionRebookingView from "./modules/generalLedger/views/DimensionRebookingView.vue";
import BookingTemplateEditor from "./modules/generalLedger/views/BookingTemplateEditor.vue";
import GeneralLedgerMatching from "./modules/transactions/views/GeneralLedgerMatching.vue";
import GeneralLedgerMatchingEditor from "./modules/transactions/components/GeneralLedgerMatchingEditor.vue";

//Fizetési határidő karbantartó
import PartnerPayDateView from "@/modules/partnerPayDate/views/PartnerPayDateView.vue";
import PartnerPayDateEditor from "@/modules/partnerPayDate/views/PartnerPayDateEditor.vue";

//Metis riport karbantartó
import MetRiportView from "@/modules/metisRiport/views/MetRiportView.vue";
import MetRiportEditor from "@/modules/metisRiport/views/MetRiportEditor.vue";
import MetRiportExportEditor from "@/modules/metisRiport/views/MetRiportExportEditor.vue";

//Címke karbantartó
import ObjectMarksView from "./modules/objectMark/views/ObjectMarksView.vue";

//Felvásárlási jegy
import globalStore from "./models/GlobalStore";
import TwoFactorAuthenticationPage from "./views/Settings/Pages/TwoFactorAuthenticationPage.vue";

//CashFlow riort
import CashFlowRiportView from "@/modules/cashFlowRiport/views/CashFlowRiportView.vue";
import CashFlowRiportEditor from "@/modules/cashFlowRiport/views/CashFlowRiportEditor.vue";

//Külső interfész szinkronok
import InterfaceView from "@/modules/interface/views/InterfaceView.vue";
import SyncEntityEditor from "@/modules/interface/views/SyncEntityEditor.vue";

Vue.use(VueRouter);

const MainComponent = configuration.operel ? {} : SettingsPage;

const settingsChildren: RouteConfig[] = [
    {
        path: "banks",
        name: "Banks",
        component: BanksPage,
    },
    {
        path: "account/action-source",
        name: "AccountActionSources",
        component: AccountActionSourcesPage,
    },
    {
        path: "account/account-type",
        name: "AccountTypes",
        component: AccountTypesPage,
    },
    {
        path: "invoice-group",
        name: "InvoiceGroups",
        component: InvoiceGroupsPage,
    },
    {
        path: "invoice-group-approvals",
        name: "InvoiceGroupApprovals",
        component: InvoiceGroupApprovalsPage,
    },
    {
        path: "payment-mode",
        name: "PaymentModes",
        component: PaymentModesPage,
    },
    {
        path: "acc-item-param",
        name: "AccItemParams",
        component: AccItemParamsPage,
    },
    {
        path: "cash-points",
        name: "CashPoints",
        component: CashPointsPage,
    },
    {
        path: "/account/action-source/:accountActionSourceId",
        name: "accountActionSourceEdit",
        component: AccountActionSourcePage,
    },
    {
        path: "/account/account-type/:accountTypeId",
        name: "AccountTypeEdit",
        component: AccountTypePage,
    },
    {
        path: "/invoice-group/create",
        name: "InvoiceGroup",
        component: InvoiceGroupPage,
    },
    {
        path: "/tax",
        name: "TaxesPage",
        component: TaxesPage,
    },
    {
        path: "/tax/create",
        name: "TaxCreate",
        component: TaxPage,
    },
    {
        path: "/tax/:taxId/edit",
        name: "TaxEdit",
        component: TaxPage,
    },
    {
        path: "/invoice-group/:invoiceGroupId/edit",
        name: "InvoiceGroupEdit",
        component: InvoiceGroupPage,
    },
    {
        path: "/payment-mode/create",
        name: "PaymentModeCreate",
        component: PaymentModePage,
    },
    {
        path: "/payment-mode/:paymentModeId/edit",
        name: "PaymentModeEdit",
        component: PaymentModePage,
    },
    {
        path: "/cash-points/:cashPointId",
        name: "cashPointEdit",
        component: CashPointPage,
    },
    {
        path: "/cash-points/create",
        name: "cashPointCreate",
        component: CashPointPage,
    },
    {
        path: "/banks/create",
        name: "BankCreate",
        component: BankPage,
    },
    {
        path: "/bank/:bankId/edit",
        name: "BankEdit",
        component: BankPage,
    },
    {
        path: "/currency-rates",
        name: "CurrencyRates",
        component: CurrencyRatesPage,
    },
    {
        path: "/currency-rates/create",
        name: "CurrencyRatesCreate",
        component: CurrencyRatePage,
    },
    {
        path: "/document-templates",
        name: "InvoiceFlowSettings",
        component: InvoiceFlowSettingsPage,
    },
    {
        path: "/approval-matrix",
        name: "ApprovalMatrixSettings",
        component: ApprovalMatrixPage,
    },
    {
        path: "/incoming-invoice-type",
        name: "IncomingInvoiceTypes",
        component: IncomingInvoiceTypesPage,
    },
    {
        path: "/incoming-invoice-type/edit/:typeId",
        name: "IncomingInvoiceType",
        component: IncomingInvoiceTypePage,
    },
    {
        path: "/invoice-types",
        name: "InvoiceTypes",
        component: InvoiceTypesPage,
    },
    {
        path: "/invoice-types/create",
        name: "InvoiceTypeCreate",
        component: InvoiceTypePage,
    },
    {
        path: "/invoice-types/:invoiceTypeId/edit",
        name: "InvoiceTypeEdit",
        component: InvoiceTypePage,
    },
    {
        path: "/outgoing-invoice/type",
        name: "OutgoingInvoiceTypeEditModels",
        component: OutgoingInvoiceTypeEditModelsPage,
    },
    {
        path: "/outgoing-invoice/type/:outgoingInvoiceTypeId/edit",
        name: "OutgoingInvoiceTypeEditModelEdit",
        component: OutgoingInvoiceTypeEditModelPage,
    },
    {
        path: "/outgoing-invoice/type/create",
        name: "OutgoingInvoiceTypeEditModelCreate",
        component: OutgoingInvoiceTypeEditModelPage,
    },
    {
        path: "/account-voucher-types",
        name: "AccountVoucherTypes",
        component: AccountVoucherTypesPage,
    },
    {
        path: "/account-voucher-types/:accountVoucherTypeId",
        name: "AccountVoucherTypeEdit",
        component: AccountVoucherTypePage,
    },
    {
        path: "/account-voucher-types/create",
        name: "AccountVoucherTypeCreate",
        component: AccountVoucherTypePage,
    },
    {
        path: "/account-codes/editmodels",
        name: "AccountCodeEditmodels",
        component: AccountCodeEditModelsPage,
    },
    {
        path: "/account-codes/list",
        name: "AccountCodeEditList",
        component: AccountCodeEditList,
    },
    {
        path: "/account-codes/editmodels/:accountCodeId/:columnDictionaryId",
        name: "AccountCodeEditModelEdit",
        component: AccountCodeEditModelPage,
    },
    {
        path: "/parameters",
        name: "SystemParameters",
        component: SystemParametersPage,
    },
    {
        path: "/user-acc-no",
        name: "UserAccountNos",
        component: UserAccountNosPage,
    },
    {
        path: "/user-acc-no/:accountId/edit",
        name: "UserAccountNo",
        component: UserAccountNoPage,
    },
    {
        path: "/user-acc-no/create",
        name: "UserAccountNoCreate",
        component: UserAccountNoPage,
    },
    {
        path: "/roles",
        name: "Roles",
        component: Roles,
    },
    {
        path: "/generalLedgerPeriods",
        name: "GeneralLedgerPeriods",
        component: GeneralLedgerPeriods,
    },
    {
        path: "/dim-code-types",
        name: "DimCodeTypes",
        component: DimCodeTypesPage,
    },
    {
        path: "/invoice-parameter",
        name: "InvoiceParameter",
        component: InvoiceParameterPage,
    },
    {
        path: "/invoice-parameter/:InvoiceParamsId",
        name: "InvoiceParameterEdit",
        component: InvoiceParameterEditPage,
    },
    {
        path: "/bank-extract-import-account-type",
        name: "BankExtractImportAccountTypeEdit",
        component: BankExtractImportAccountTypeEdit,
    },
    {
        path: "/fix-asset/groups",
        name: "FixAssetGroupsPage",
        component: FixAssetGroupsPage,
    },
    {
        path: "/fix-asset/groups/:fixAssetGroupId",
        name: "FixAssetGroupPage",
        component: FixAssetGroupPage,
    },
    {
        path: "/invoice/migration",
        name: "InvoiceMigrationPage",
        component: InvoiceMigrationPage,
    },
    //Pc kód karbantartó
    {
        path: "/pc-codes",
        name: "PcCodeView",
        component: PcCodeView,
    },
    //Fizetési határidő karbantartó
    {
        path: "/partner-paydates",
        component: PartnerPayDateView,
        name: "PartnerPayDateView",
    },
    {
        path: "/partner-paydate/paydate/create",
        component: PartnerPayDateEditor,
        name: "PartnerPayDateCreate",
    },
    {
        path: "/partner-paydate/paydate/edit/:payDateId",
        component: PartnerPayDateEditor,
        name: "PartnerPayDateEditor",
    },
    //Metis riport karbantartó
    {
        path: "/met-riport",
        name: "MetRiportsView",
        component: MetRiportView,
    },    
    {
        path: "/met-riport/create",
        name: "MetRiportCreate",
        component: MetRiportEditor,
    },
    {
        path: "/met-riport/edit/:metRiportId",
        name: "MetRiportEditor",
        component: MetRiportEditor,
    },
    {
        path: "/met-riport/:metRiportId/export/create",
        name: "MetRiportExportCreate",
        component: MetRiportExportEditor,
    },
    {
        path: "/met-riport/export/edit/:metExportId",
        name: "MetRiportExportEditor",
        component: MetRiportExportEditor,
    },
    //Címke karbantartó
    {
        path: "/object-marks",
        name: "ObjectMarksView",
        component: ObjectMarksView,
    },    
];

function filtered(settingsChildren: RouteConfig[]) {
    return settingsChildren.filter((x) => {
        if (!x.name) return false;
        return [
            "Banks",
            "BankCreate",
            "BankEdit",
            "ApprovalMatrixSettings",
            "InvoiceFlowSettings",
            "UserAccountNos",
            "UserAccountNo",
            "UserAccountNoCreate",
            "SystemParameters",
            "Roles",
            "TaxesPage",
            "TaxCreate",
            "TaxEdit",
            "AccountCodeEditmodels",
            "AccountCodeEditModelEdit",
            "DimCodeTypes",
            "InvoiceParameter",
            "CreditCardPage",
            "PcCodesPage",
            "MetRiportHeads",
            "MetRiportHead"
        ].includes(x.name);
    });
}

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "LandingPage",
        component: Home,
    },
    {
        path: "/reports",
        name: "Reports",
        component: ReportsPage,
    },
    {
        path: "/settings",
        name: "Settings",
        component: MainComponent,
        children: process.env.VUE_APP_SETTINGS_HIDDEN === "true" ? filtered(settingsChildren) : settingsChildren,
    },
    {
        path: "/partners",
        name: "PartnerDetails",
        component: PartnerDetailsPage,
    },
    {
        // Partner összevezetés; az opcionális ID-k előtöltik a kivezetendő és a megmaradó partnert
        path: "/partner-matching/:transferPartnerId?/:keepPartnerId?",
        name: "PartnerMatching",
        component: PartnerMatchingPage,
    },
    {
        path: "/partners/create/:source?",
        name: "PartnerCreate",
        component: PartnerPage,
    },
    {
        path: "/partners/:partnerId/:source?",
        name: "PartnerEdit",
        component: PartnerEditPage,
    },
    {
        path: "/partners/:partnerId/:source?/create-part-bank",
        name: "PartBankCreate",
        component: PartBankCreatePage,
    },
    {
        path: "/partners/:partnerId/:source?/create-part-supplier",
        name: "PartSupplierCreate",
        component: PartSupplierCreatePage,
    },
    {
        path: "/partners/:partnerId/:source?/create-part-customer",
        name: "PartCustCreate",
        component: PartCustCreatePage,
    },
    {
        path: "/partners/:partnerId/:source?/create-part-person",
        name: "PartPersonCreate",
        component: PartPersonCreatePage,
    },
    {
        path: "/partners/:partnerId/:source?/edit-part-person/:partPersonId",
        name: "PartPersonCreate",
        component: PartPersonCreatePage,
    },
    //// általános dokumentum böngésző, feltöltő, még nincs kész TODO
    // {
    //   path: "/documents",
    //   name: "DocumentBrowser",
    //   component: DocumentBrowser,
    // },
    // {
    //   path: "/documents/create",
    //   name: "DocumentCreatePage",
    //   component: DocumentCreatePage,
    // },
    {
        path: "/login",
        name: "Login",
        component: LoginPage,
    },
    {
        path: "/general-incoming-invoice/:invoiceFilter?",
        name: "GeneralIngoingInvoices",
        component: GeneralIngoingInvoicesPage,
    },
    {
        path: "/general-incoming-invoice/create",
        name: "GeneralIngoingInvoicePartnerSearch",
        component: GeneralIngoingInvoicePartnerSearch,
        meta: {
            isPictureRequired: true,
        }
    },
    {
        path: "/settings",
        name: "Settings",
        component: MainComponent,
        children: process.env.VUE_APP_SETTINGS_HIDDEN === "true" ? filtered(settingsChildren) : settingsChildren,
    },
    {
        path: "/partners",
        name: "PartnerDetails",
        component: PartnerDetailsPage,
    },
    {
        path: "/partners/create/:source?",
        name: "PartnerCreate",
        component: PartnerPage,
    },
    {
        path: "/partners/create/:source?/:bank?/:itemid?",
        name: "PartnerCreateBank",
        component: PartnerPage,
    },
    {
        path: "/partners/:partnerId/:source?",
        name: "PartnerEdit",
        component: PartnerEditPage,
    },
    {
        path: "/partners/:partnerId/:source?/create-part-bank",
        name: "PartBankCreate",
        component: PartBankCreatePage,
    },
    {
        path: "/partners/:partnerId/:source?/create-part-supplier",
        name: "PartSupplierCreate",
        component: PartSupplierCreatePage,
    },
    {
        path: "/partners/:partnerId/:source?/create-part-customer",
        name: "PartCustCreate",
        component: PartCustCreatePage,
    },
    {
        path: "/partners/:partnerId/:source?/create-part-person",
        name: "PartPersonCreate",
        component: PartPersonCreatePage,
    },
    //// általános dokumentum böngésző, feltöltő, még nincs kész TODO
    // {
    //   path: "/documents",
    //   name: "DocumentBrowser",
    //   component: DocumentBrowser,
    // },
    // {
    //   path: "/documents/create",
    //   name: "DocumentCreatePage",
    //   component: DocumentCreatePage,
    // },
    {
        path: "/login",
        name: "Login",
        component: LoginPage,
    },
    {
        path: "/general-incoming-invoice",
        name: "GeneralIngoingInvoices",
        component: GeneralIngoingInvoicesPage,
    },
    {
        path: "/general-incoming-invoice/create",
        name: "GeneralIngoingInvoicePartnerSearch",
        component: GeneralIngoingInvoicePartnerSearch,
        meta: {
            isPictureRequired: true,
        },
    },
    {
        path: "/general-incoming-invoice/create/diff-vat",
        name: "GeneralIngoingInvoicePartnerSearch",
        component: GeneralIngoingInvoicePartnerSearch,
        meta: {
            isPictureRequired: true,
        },
    },
    {
        path: "/general-incoming-invoice/flow/create/:partnerId",
        name: "InvoiceFlowCreate",
        component: InvoiceFlowPage,
        meta: {
            isPictureRequired: true,
        },
    },
    {
        path: `/general-incoming-invoice/flow/create/${globalStore.incomingInvoiceFilter.ProdPurchase}/:partnerId`,
        name: "InvoiceFlowCreate",
        component: InvoiceFlowPage,
        meta: {
            isPictureRequired: true,
        },
    },
    {
        path: "/general-incoming-invoice/flow/edit/:invoiceId",
        name: "InvoiceFlowEdit",
        component: InvoiceFlowPage,
        meta: {
            isPictureRequired: true,
        },
    },
    {
        path: "/general-incoming-invoice/flow/edit/:invoiceId/:step/:partnerId?",
        name: "InvoiceFlowEditInStep",
        component: InvoiceFlowPage,
        meta: {
            isPictureRequired: true,
        },
    },
    {
        path: "/general-incoming-invoice/flow/edit-simple/:invoiceId",
        name: "InvoiceEditAfterVatConfession",
        component: InvoiceEditAfterVatConfession,
    },
    {
        path: "/general-incoming-invoice/create/:partnerId",
        name: "GeneralIngoingInvoiceCreate",
        component: IncomingInvoicePage,
        meta: {
            isPictureRequired: true,
        },
    },
    {
        path: "/general-incoming-invoice/edit/:partnerId/:invoiceId",
        name: "GeneralIngoingInvoiceEdit",
        component: IncomingInvoicePage,
        meta: {
            isPictureRequired: true,
        },
    },
    {
        path: "/invoice-browser/technical/:codeFilter",
        name: "TechnicalInvoiceBrowser",
        component: TechnicalInvoiceBrowser,
    },
    {
        path: "/invoice-browser/technical-invoice/:codeFilter",
        name: "PartnerSelectView",
        component: () => import("@/modules/technicalInvoice/views/PartnerSelectView.vue"),
    },
    {
        path: "/invoice-browser/technical-invoice/:codeFilter/create",
        name: "TechnicalInvoicePageCreate",
        component: () => import("@/modules/technicalInvoice/views/TechnicalInvoicePage.vue"),
    },
    {
        path: "/invoice-browser/technical-invoice/:codeFilter/edit/:invoiceId",
        name: "TechnicalInvoicePageEdit",
        component: () => import("@/modules/technicalInvoice/views/TechnicalInvoicePage.vue"),
    },
    {
        path: "/invoice-browser",
        name: "InvoiceBrowser",
        component: InvoiceBrowser,
        children: [
            {
                path: ":typeFilter/:filtered?",
                name: "InvoiceBrowser",
                component: InvoiceBrowser,
            }
        ],
    },
    {
        path: "/invoice-flow-task",
        name: "InvoiceFlowTaskPage",
        component: InvoiceFlowTaskPage,
    },
    {
        path: "/cash-statement",
        name: "CashStatementsApiSearchPage",
        component: CashStatementsApiSearchPage,
    },
    {
        path: "/current-account",
        name: "CurrentAccount",
        component: CurrentAccountPage,
    },
    {
        path: "/current-account/arrangement",
        name: "CurrentAccountArrangement",
        component: CurrentAccountArrangementPage,
    },
    {
        path: "/write-off-debt",
        name: "WriteOffDebt",
        component: WriteOffDebtPage,
        props: true,
        children: [
            {
                path: "invoices",
                name: "WriteOffDebtInvoices",
                component: WriteOffDebtInvoicesPage,
            },
            {
                path: "write-off",
                name: "WriteOff",
                component: WriteOffPage,
            },
        ],
    },
    {
        path: "/cash-statement/create",
        name: "CashStatementCashPointSearchPage",
        component: CashStatementCashPointSearch,
    },
    {
        path: "/cash-statement/create/:cashPointId",
        name: "CashStatementCreatePage",
        component: CashStatementPage,
    },
    {
        path: "/cash-statement/edit/:cashStatementId",
        name: "CashStatementEditPage",
        component: CashStatementPage,
    },
    {
        path: "/cash-statement/edit/:cashStatementId/:cashDocumentId",
        name: "CashDocumentEditPage",
        component: CashDocumentPage,
    },
    {
        path: "/viri-item/create",
        name: "VIRIItemPage",
        component: VIRIItemPage,
    },
    {
        path: "/viri-item/edit/:invoiceId",
        name: "VIRIItemPage",
        component: VIRIItemPage,
    },
    {
        path: "/customs-invoice/edit/:invoiceId",
        name: "CustomsInvoicePage",
        component: CustomsInvoicePage,
    },
    {
        path: "/customs-invoice",
        name: "CustomsInvoicesPage",
        component: CustomsInvoicesPage,
    },
    {
        path: "/bank-statements",
        name: "BankStatementsApiSearchPage",
        component: BankStatementsApiSearchPage,
    },
    {
        // Banki kontírozás — a lezárt bankkivonatok böngészése/szűrése és
        // csoportos (újra)kontírozása (K2D w_popup_bank_cash, bank üzemmód)
        path: "/bank-pre-accounting",
        name: "BankPreAccStatementsView",
        component: BankPreAccStatementsView,
    },
    {
        // Adott bankkivonat kontírozási tételei (K2D w_popup_bank_accitem_os)
        path: "/bank-pre-accounting/:id/edit",
        name: "BankPreAccEdit",
        component: BankPreAccEditorView,
    },
    {
        // Pénztár kontírozása — a lezárt pénztárkivonatok böngészése/szűrése és
        // csoportos (újra)kontírozása (K2D w_popup_bank_cash, pénztár üzemmód)
        path: "/cash-pre-accounting",
        name: "CashPreAccStatementsView",
        component: CashPreAccStatementsView,
    },
    {
        // Adott pénztárkivonat kontírozási tételei (K2D w_popup_cash_accitem_os)
        path: "/cash-pre-accounting/:id/edit",
        name: "CashPreAccEdit",
        component: CashPreAccEditorView,
    },
    {
        // Be/kitárolások kontírozása — a kontírozásra alkalmas tároló-bizonylatok (és
        // KÉK MIX bizonylatok) böngészése/szűrése, csoportos (újra)kontírozása és
        // státusz állítása (K2D w_popup_bank_cash, 3-as be/kitárolás üzemmód). A kontír
        // szerkesztése a számla előkontírozás MIX-szerkesztőjében nyílik
        // (/pre-accounting/MIX/:invNo/edit — K2D w_response_mix ii_oper = 7).
        path: "/store-in-out-pre-accounting",
        name: "StoreInOutPreAccDocsView",
        component: StoreInOutPreAccDocsView,
    },
    {
        // Folyószámla rendező műveletek kontírozása (K2D xdpaccinv_cont
        // w_popup_action_cont_new) — DLMP480. Jogosultsági kulcs egyeztetés után
        // a többi kontírozás böngésző mintájára kapcsolandó be a guard.
        path: "/current-account-pre-accounting",
        name: "CurrentAccountPreAccActionsView",
        component: CurrentAccountPreAccActionsView,
    },
    {
        path: "/bank-statement/create/:id",
        name: "BankStatementFlowPage",
        component: BankStatementFlowPage,
        children: [
            {
                path: "head",
                name: "BankStatementCreatePage",
                component: BankStatementCreatePage,
            },
            {
                path: "item",
                name: "BankStatementItemsPage",
                component: BankStatementItemsPage,
            },
            {
                path: "approval",
                name: "BankStatementApprovalPage",
                component: BankStatementApprovalPage,
            },
        ],
    },
    {
        path: "/down-payment",
        name: "DownPaymentsPage",
        component: DownPaymentsPage,
    },
    {
        path: "/down-payment/search",
        name: "DownPaymentSearchPage",
        component: DownPaymentSearchPage,
    },
    {
        path: "/down-payment/create/:partnerId",
        name: "DownPaymentCreatePage",
        component: DownPaymentRequestPage,
    },
    {
        path: "/down-payment/edit/:invoiceId",
        name: "DownPaymentEditPage",
        component: DownPaymentRequestPage,
    },
    {
        path: "/debit-payment",
        name: "DebitPaymentsView",
        component: DebitPaymentView,
    },
    {
        path: "/debit-payment/edit/:partnerId/:invoiceId",
        name: "DebitPaymentEditPage",
        component: DebitPaymentEditPage,
    },
    {
        path: "/debit-payment/create/:partnerId",
        name: "DebitPaymentCreatePage",
        component: DebitPaymentEditPage,
    },
    {
        path: "/debit-payment/search",
        name: "DebitPaymentSearchPage",
        component: DebitPaymentSearchPage,
    },
    {
        path: "/action-log",
        name: "ActionLogPage",
        component: ActionLogPage,
    },
    {
        path: "/invoice-parameter",
        name: "InvoiceParameterPage",
        component: InvoiceParameterPage,
    },
    {
        path: "/invoice-deadlines",
        name: "InvoiceDeadlines",
        component: InvoiceDeadlinesPage,
    },
    {
        path: "/uninvoiced-stock-correction",
        name: "UninvoicedStockCorrections",
        component: UninvoicedStockCorrectionsPage,
    },
    {
        path: "/uninvoiced-stock-correction/create",
        name: "UninvoicedStockCorrectionPartnerSearch",
        component: UninvoicedStockCorrectionSearchPage,
    },
    {
        path: "/uninvoiced-stock-correction/create/:partnerId",
        name: "UninvoicedStockCorrectionCreate",
        component: UninvoicedStockCorrectionEditPage,
    },
    {
        path: "/uninvoiced-stock-correction/edit/:invoiceId",
        name: "UninvoicedStockCorrectionEdit",
        component: UninvoicedStockCorrectionEditPage,
    },
    {
        path: "/bank-remits",
        name: "BankRemitsPage",
        component: BankRemitsPage,
    },
    {
        path: "/bank-remits-account",
        name: "BankSelectView",
        component: BankSelectView,
    },
    {
        path: "/bank-remits/create/:id",
        name: "BankRemitCreatePage",
        component: BankRemitCreatePage,
        children: [
            {
                path: "head",
                name: "BankRemitHeadView",
                component: BankRemitHeadView,
            },
            {
                path: "item",
                name: "BankRemitItemView",
                component: BankRemitItemView,
            },
            {
                path: "approval",
                name: "BankRemitApprovalView",
                component: BankRemitApprovalView,
            },
            {
                path: "forward",
                name: "BankRemitForwarding",
                component: BankRemitForwardingView,
            },
        ],
    },
    {
        path: "/incoming-invoice/:invoiceId/accounting",
        name: "InvoiceAccounting",
        component: InvoiceAccounting,
    },
    {
        path: "/bank-extract-import",
        name: "BankExtractImports",
        component: BankExtractImportsPage,
    },
    {
        path: "/stock-financing-import",
        name: "StockFinancingImport",
        component: StockFinancingImportPage,
    },
    {
        path: "/bank-extract-import/edit/:headId",
        name: "BankExtractImportEdit",
        component: BankExtractImportEditPage,
    },
    {
        path: "/bank-extract-import/create",
        name: "BankExtractImportCreate",
        component: BankExtractImportCreatePage,
    },
    {
        path: "/power-bi/:id/:paramId?",
        name: "PowerBIPage",
        component: PowerBIPage,
    },
    {
        path: "transfer-notify",
        name: "BankTransferNotifyReportPage",
        component: BankTransferNotifyReportPage,
    },
    {
        path: "transfer-remit",
        name: "BankTransferRemitReportPage",
        component: BankTransferRemitReportPage,
    },
    {
        path: "/accounting-queries/transaction-items",
        name: "GeneralLedgerTransactionGrid",
        component: GeneralLedgerTransactionGrid,
    },
    {
        path: "/accounting-queries/fullfilment-tolerance-level",
        name: "FullfilmentTolerancesPage",
        component: FullfilmentTolerancesPage,
    },
    {
        path: "/credit-cards",
        name: "CreditCardsPage",
        component: CreditCardsPage,
    },
    {
        path: "/credit-card/:id",
        name: "CreditCardPage",
        component: CreditCardPage,
    },
    {
        path: "/letters-of-credit",
        name: "LettersOfCreditPage",
        component: LettersOfCreditPage,
    },
    {
        path: "/letters-of-credit/:id",
        name: "LetterOfCreditPage",
        component: LetterOfCreditPage,
    },
    {
        path: "/change-password",
        name: "ChangePasswordPage",
        component: ChangePasswordPage,
    },
    {
        path: "/two-factor-authentication",
        name: "TwoFactorAuthenticationPage",
        component: TwoFactorAuthenticationPage,
    },
    {
        path: "/acc-complaints",
        name: "AccComplaintsTable",
        component: AccComplaintsTable,
    },
    {
        path: "/general-outgoing-invoices",
        component: GeneralOutgoingInvoiceLayout,
        name: "GeneralOutgoingInvoiceLayout",
        children: [
            {
                path: "proform-to-final",
                component: ProformToInvoiceView,
                name: "ProformToInvoiceView",
            },
            {
                path: "pay-open-invoices",
                component: PayOpenInvoicesView,
                name: "PayOpenInvoicesView",
            },
            {
                path: "pay-open-invoices/:prefix/:invNo",
                component: PayOpenInvoicesView,
                name: "PayOpenInvoicesView",
            },
            {
                path: "viri-invoices",
                component: VIRIPage,
                name: "VIRIPage",
            },
        ],
    },
    {
        path: "/open-payoff-downpayments",
        component: OpenPayoffDownpaymentsView,
        name: "OpenPayoffDownpaymentsView",
    },
    {
        path: "/ledger-submits",
        component: InvoiceLedgerSubmissionView,
        name: "InvoiceLedgerSubmissionView",
    },
    {
        path: "/general-incoming-invoice/kanri/:objectId",
        name: "KanriRedirectPageForGeni",
        component: KanriRedirectPage,
    },
    {
        path: "/geno-experimental-invoices/kanri/:objectId",
        name: "KanriRedirectPageForGenoAndIntr",
        component: KanriRedirectPage,
    },
    {
        path: "/noto/kanri/:objectId",
        name: "KanriRedirectPageForNoto",
        component: KanriRedirectPage,
    },
    {
        path: "/kanri-invoices/purchase",
        name: "KanriInvoicesPurchase",
        component: KanriInvoicesPage,
    },
    {
        path: "/kanri-invoices/purchase/car-agreements",
        name: "KanriCarAgreementInvoicess",
        component: KanriCarAgreementInvoicesPage,
    },
    {
        path: "/kanri-invoices/sale",
        name: "KanriInvoicesSale",
        component: KanriInvoicesPage,
    },
    {
        path: "/kanri-invoices/:id",
        name: "KanriInvoices",
        component: KanriInvoicesPage,
    },
    {
        path: "/geno-experimental-invoices",
        name: "GenoExperimentalInvoicePage",
        component: GenoExperimentalInvoicePage,
    },
    {
        path: "/geno-experimental-invoices/:id",
        name: "GenoExperimentalInvoiceEditPage",
        component: GenoExperimentalInvoiceEditPage,
    },
    {
        path: "/notice",
        name: "Notices",
        component: NoticesPage,
    },
    {
        path: "/notice/create",
        name: "NoticePartnerSearch",
        component: NoticePartnerPage,
    },
    {
        path: "/notice/create/0",
        name: "NoticeCreate",
        component: NoticePage,
    },
    {
        path: "/noto/:noticeId",
        name: "NoticeEdit",
        component: NoticePage,
    },
    {
        path: "/caro",
        name: "CaroStornoPage",
        component: CaroStornoPage,
    },
    {
        path: "/invoice-import",
        name: "InvoiceImportPage",
        component: InvoiceImportPage,
    },
    {
        path: "/invoice-import/items",
        name: "InvoiceItemsImportPage",
        component: InvoiceItemsImportPage,
        props: true,
    },
    {
        path: "/download-invoices",
        name: "DownloadableInvoices",
        component: DownloadableInvoices,
    },
    {
        path: "/invoice-import-view",
        name: "InvoiceImportViewPage",
        component: InvoiceImportViewPage,
    },
    //Főkönyvi tranzakciók modul
    {
        path: "/transactions",
        name: "TransactionsView",
        component: TransactionsView,
    },
    {
        path: "/transactions/create/1",
        name: "TransactionCreate",
        component: TransactionEditor,
    }, 
    {
        path: "/transactions/copy/:id",
        name: "TransactionCopy",
        component: TransactionEditor,
    },
    {
        // Egyetlen belépési pont a meglévő tranzakcióhoz — a szerkeszthetőséget a fej
        // státusza dönti el a szerkesztőben (a korábbi /transactions/view/:id megszűnt).
        path: "/transactions/edit/:id",
        name: "TransactionEdit",
        component: TransactionEditor,
    },
    {
        path: "/auditxml",
        component: GeneralLedgerAuditXml
    },
    {
        path: "/dimension-list-report",
        component: DimensionListReportView
    },
    {
        path: "/balance-report",
        component: BalanceIncomeReportView,
        props: { mode: "M" },
    },
    {
        path: "/income-statement-report",
        component: BalanceIncomeReportView,
        props: { mode: "E" },
    },
    {
        path: "/cost-matrix",
        component: CostMatrixView
    },
    {
        path: "/general-ledger-statement",
        component: GeneralLedgerStatementView,
        props: { cartonMode: false }
    },
    {
        path: "/general-ledger-carton",
        component: GeneralLedgerStatementView,
        props: { cartonMode: true }
    },
    {
        path: "/booking-events-report",
        component: BookingEventsReportView,
    },
    {
        path: "/param-report",
        component: ParamReportView,
    },
    {
        path: "/general-ledger-report",
        component: GeneralLedgerReportView,
    },
    {
        path: "/revaluation",
        component: RevaluationView
    },
    {
        path: "/ledger-open-close",
        component: GeneralLedgerOpenCloseView
    },
    {
        path: "/dimension-transfer",
        component: DimensionTransferView
    },
    {
        path: "/monthly-extract",
        component: MonthlyExtractView
    },
    {
        path: "/riport-definitions",
        component: RiportDefinitionView
    },
    {
        path: "/riport-definitions/create/:level",
        name: "RiportDefCreate",
        component: RiportDefinitionEditView
    },
    {
        path: "/riport-definitions/edit/:level/:id",
        name: "RiportDefEdit",
        component: RiportDefinitionEditView
    },
    {
        path: "/transaction-import",
        component: TransactionImportView
    },
    {
        path: "/payroll-import",
        component: PayrollImportView
    },
    {
        path: "/ledger-export",
        component: LedgerExportView
    },
    {
        path: "/novitax-import",
        component: NovitaxImportView
    },
    {
        path: "/dimension-rebooking",
        component: DimensionRebookingView
    },
    {
        path: "/booking-templates",
        component: BookingTemplateView
    },
    {
        path: "/booking-templates/create",
        name: "BookingTemplateCreate",
        component: BookingTemplateEditor
    },
    {
        path: "/booking-templates/edit/:id",
        name: "BookingTemplateEdit",
        component: BookingTemplateEditor
    },
    {
        path: "/ledger-matching",
        name: "LedgerMatching",
        component: GeneralLedgerMatching
    },
    // Régi külön útvonal (könyvjelzők): a közös böngésző "Főkönyvi számmal" fülére irányít
    {
        path: "/ledger-matching-accno",
        redirect: { path: "/ledger-matching", query: { mode: "accno" } },
    },
    {
        path: "/ledger-matching/create",
        name: "LedgerMatchingCreate",
        component: GeneralLedgerMatchingEditor,
    },
    {
        path: "/ledger-matching/edit/:id",
        name: "LedgerMatchingEdit",
        component: GeneralLedgerMatchingEditor,
    },
    {
        path: "/pre-accounting",
        name: "PreAccInvoicesView",
        component: PreAccInvoicesView,
    },
    {
        // Új MIX (vegyes) bizonylat felvitele a semmiből (K2D w_response_mix pb_insert)
        path: "/pre-accounting/create",
        name: "PreAccCreate",
        component: PreAccEditorView,
    },
    {
        // Többszámlás kontír-szerkesztő (K2D lapozó) — a böngésző pipáiból nyílik,
        // a számla-lista a PreAccountingStore-ban utazik
        path: "/pre-accounting/edit",
        name: "PreAccEditMulti",
        component: PreAccEditorView,
    },
    {
        // GENI projekt-kapcsolatok kezelője (K2D w_popup_geni_project_os)
        path: "/pre-accounting/GENI/:invNo/projects",
        name: "PreAccGeniProjects",
        component: PreAccGeniProjectsView,
    },
    {
        path: "/pre-accounting/:prefix/:invNo/view",
        name: "PreAccView",
        component: PreAccEditorView,
    },
    {
        path: "/pre-accounting/:prefix/:invNo/edit",
        name: "PreAccEdit",
        component: PreAccEditorView,
    },
    {
        path: "/storno-summary",
        component: StornoSummaryBrowser,
        name: "StornoSummaryBrowser",
    },
    // {
    //     path: "/over-summary",
    //     component: OverSummaryBrowser,
    // name: "OverSummaryBrowser",
    // },
    {
        path: "/over-summary",
        component: OverSummaryView,
        name: "OverSummaryView",
    },
    {
        path: "/gparts/edit-list",
        component: GpartsListView,
        name: "GpartsListView",
    },
    {
        path: "/gparts/edit/0",
        component: GpartEditor,
        name: "GpartEditor1",
    },
    {
        path: "/gparts/edit/:partsID",
        component: GpartEditor,
        name: "GpartEditor2",
    },
    {
        path: "/reports/parameterized-account-report",
        name: "ParameterizedAccountReport",
        component: ParameterizedAccountReport,
    },
    {
        path: "/reports/noto/:type",
        name: "NotoReports",
        component: NotoReports,
    },
    {
        path: "/card-payments",
        name: "CardPayments",
        component: CardPayments
    },
    //CashFlow riport
    {
        path: "/cashflow-riport",
        name: "CashFlowRiportView",
        component: CashFlowRiportView,
    },
    {
        path: "/cashflow-riport/edit/:cashFlowRiportId",
        name: "CashFlowRiportEditor",
        component: CashFlowRiportEditor,
    },
    {
        path: "/cashflow-riport/edit",
        name: "CashFlowRiportEditor",
        component: CashFlowRiportEditor,
    },
    //Külső interfész szinkronok
    {
        path: "/interface",
        name: "InterfaceView",
        component: InterfaceView,
    },
    {
        path: "/interface/history",
        name: "InterfaceHistoryView",
        component: InterfaceView,
        props: { historyMode: true },
    },
    {
        path: "/interface/partner/edit/:id",
        name: "SyncPartnerEditor",
        component: SyncEntityEditor,
        props: { entityType: "partner" },
    },
    {
        path: "/interface/invoice/edit/:id",
        name: "SyncInvoiceEditor",
        component: SyncEntityEditor,
        props: { entityType: "invoice" },
    },
    {
        path: "/interface/history/partner/edit/:id",
        name: "SyncPartnerViewer",
        component: SyncEntityEditor,
        props: { entityType: "partner", viewOnly: true },
    },
    {
        path: "/interface/history/invoice/edit/:id",
        name: "SyncInvoiceViewer",
        component: SyncEntityEditor,
        props: { entityType: "invoice", viewOnly: true },
    },
];

const router = new VueRouter({
    mode: process.env.VUE_APP_ROUTER_HASH_MODE ? "hash" : "history",
    base: process.env.VUE_APP_BASE_URL ?? "",
    routes: routes,
});

function checkPermission(name: string): boolean {
    const menuPerm = auth.menuPermissions.find(x => x.name == name);
    return menuPerm?.isGranted ?? false;
}

function checkRouteAccessible(to: Route): boolean {
    if (!auth.isLoggedIn){
        return true;
    }

    if (!checkPermission('INCOMINGINVOICE')){
        const routes = [
            "/general-incoming-invoice",
            "/general-incoming-invoice/create/diff-vat",
            "/down-payment",
            "/uninvoiced-stock-correction",
            "/invoice-browser/incoming",
            "/invoice-deadlines",
            "/customs-invoice",
            "/invoice-flow-task",
            "/acc-complaints",
            "/ledger-submits",
            "/invoice-import",
            "/invoice-import-view",
            "/download-invoices",
            "/invoice-browser/technical/viri",
            "/kanri-invoices/purchase",
            "/kanri-invoices/purchase/car-agreements",
            "/general-incoming-invoice/flow/edit",
            "/general-incoming-invoice/flow/create"
        ];

        const names = ['InvoiceFlowCreate', 'InvoiceFlowEdit', 'InvoiceFlowEditInStep'];

        if (routes.includes(to.path) || names.includes(to.name ?? "")){
            return false;
        }
    }
    if (!checkPermission('INVOICES')){
        const routes = ['/general-incoming-invoice'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    if (!checkPermission('INVOICEPRODPURCH') || !configuration.sysParams.useProdPurchase){
        const routes = ['/general-incoming-invoice/prod-purchase'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    if (!checkPermission('DPAYM')){
        const routes = ['/down-payment'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    // if (!checkPermission('UNINVOICESTOCKCOR')){
    if (!checkPermission('INVSTOCK')){
        const routes = ['/uninvoiced-stock-correction'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    if (!checkPermission('INVOICEBROINCOM')){
        const routes = ['/invoice-browser/incoming'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    if (!checkPermission('INVDEADLINE')){
        const routes = ['/invoice-deadlines'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    // if (!checkPermission('INVOICECUSTOMS')){
    if (!checkPermission('CUSTOMSINV')){
        const routes = ['/customs-invoice'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    if (!checkPermission('INVOICEFLOWTASK')){
        const routes = ['/invoice-flow-task'];

        if (routes.includes(to.path)){
            return false;
        }
    } 
    // if (!checkPermission('INVOICEACCCOMPL')){
    if (!checkPermission('ACCCOMPLAINT')){
        const routes = ['/acc-complaints'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    // if (!checkPermission('INVOICELEDGERSUB')){
    if (!checkPermission('LEDGERSUBMIT')){
        const routes = ['/ledger-submits'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    if (!checkPermission('INVOICEIMPORTPAGE')){
        const routes = ['/invoice-import'];

        if (routes.includes(to.path)){
            return false;
        }
    }

    if (!checkPermission('INVOICEIMPORTVIEWPAGE')){
        const routes = ['/invoice-import-view'];

        if (routes.includes(to.path)){
            return false;
        }
    }

    if (!checkPermission('DOWNLOADINV')){
        const routes = ['/download-invoices'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    if (!checkPermission('INVTECHVIRI')){
        const routes = ['/invoice-browser/technical/viri'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    if (!checkPermission('KANRIPURCHASE')){
        const routes = ['/kanri-invoices/purchase'];

        if (routes.includes(to.path)){
            return false;
        }
    }
    if (!checkPermission('KANRICARAGREE')){
        const routes = ['/kanri-invoices/purchase/car-agreements'];

        if (routes.includes(to.path)){
            return false;
        }
    }

    if (!checkPermission('OUTGOINGINVOICE')){
        const routes = [
            "/invoice-browser/outgoing",
            "/general-outgoing-invoices/proform-to-final",
            "/general-outgoing-invoices/pay-open-invoices",
            "/general-outgoing-invoices/viri-invoices",
            "/notice",
            "/caro",
            "/invoice-browser/technical/viro",
            "/kanri-invoices/sale",
            "/geno-experimental-invoices"
        ];

        if (routes.includes(to.path)){
            return false;
        }
    }

    if (!checkPermission('OUTINVBROW')){
        const routes = ['/invoice-browser/outgoing'];

        if (routes.includes(to.path)){
            return false;
        }
    }

    if (!checkPermission('OUTPROTOFIN')) {
        const routes = ['/general-outgoing-invoices/proform-to-final'];
        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('OUTCARDPAY')) {
        const routes = ['/general-outgoing-invoices/pay-open-invoices'];
        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('HATOSAGICSEKK')) {
        const routes = ['/general-outgoing-invoices/viri-invoices'];
        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('OUTNOTICE')) {
        const routes = ['/notice'];
        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('STORNOINV')) {
        const routes = ['/caro'];
        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('VIROS')) {
        const routes = ['/invoice-browser/technical/viro'];
        if (routes.includes(to.path)) {
            return false;
        }
    }
        // if (!checkPermission('OUTPAYBYCARD')) {
        if (!checkPermission('CARDPAYMENTS')) {
            const routes = ['/card-payments'];
            if (routes.includes(to.path)) {
            return false;
            }
        }
    if (!checkPermission('KANRIIMPORT')) {
        const routes = ['/kanri-invoices/sale'];
        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('KANRIPROFORM')) {
        const routes = ['/geno-experimental-invoices'];
        if (routes.includes(to.path)) {
            return false;
        }
    }

    if (!checkPermission('BANK')){
        const routes = [
            "/bank-remits",
            "/bank-statements",
            "/bank-extract-import",
            "/stock-financing-import",
            "/credit-cards",
            "/letters-of-credit"
        ];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('BANKREMIT')){
        const routes = ['/bank-remits'];

        if (routes.includes(to.path)) {
            return false;
        }
    } 
    if (!checkPermission('BANKSTATMENTS')){
        const routes = ['/bank-statements'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('BANKEXTRACTIMPORT')){
        const routes = ['/bank-extract-import'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('STOCKFINANCINGIMPORT')){
        //const routes = ['/stock-financing-import'];
        const routes = [''];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('BANKCREDITCARDS')){
        const routes = ['/credit-cards'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('LETTEROFCREDIT')){
        const routes = ['/letters-of-credit'];

        if (routes.includes(to.path)) {
            return false;
        }
    }

    if (!checkPermission('CASHPOINT')){
        const routes = ['/cash-statement', '/open-payoff-downpayments'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('CASHSTATEMENT')){
        const routes = ['/cash-statement'];

        if (routes.includes(to.path)) {
            return false;
        }
    } 
    if (!checkPermission('CASHOPENPAYOFFDOWNPAYMENTS')){
        const routes = ['/open-payoff-downpayments'];

        if (routes.includes(to.path)) {
            return false;
        }
    }

    // TODO: BANKPREACCOUNTING jogosultsági kulcs felvétele után visszakapcsolni
    // (az AppMenu-ben is ki van kommentelve a checkPermission('BANKPREACCOUNTING'))
    // if (!checkPermission('BANKPREACCOUNTING')){
    //     const routes = ['/bank-pre-accounting'];
    //
    //     if (routes.includes(to.path)) {
    //         return false;
    //     }
    // }

    // TODO: CASHPREACCOUNTING jogosultsági kulcs felvétele után visszakapcsolni
    // (az AppMenu-ben is ki van kommentelve a checkPermission('CASHPREACCOUNTING')).
    // startsWith, hogy a szerkesztő útvonala (/cash-pre-accounting/:id/edit) is a
    // kapu alá essen.
    // if (!checkPermission('CASHPREACCOUNTING')){
    //     if (to.path.startsWith('/cash-pre-accounting')) {
    //         return false;
    //     }
    // }

    // TODO: STOREINOUTPREACCOUNTING jogosultsági kulcs felvétele után visszakapcsolni
    // (az AppMenu-ben is ki van kommentelve a checkPermission('STOREINOUTPREACCOUNTING'))
    // if (!checkPermission('STOREINOUTPREACCOUNTING')){
    //     const routes = ['/store-in-out-pre-accounting'];
    //
    //     if (routes.includes(to.path)) {
    //         return false;
    //     }
    // }

    // TODO: CURRENTACCOUNTPREACCOUNTING jogosultsági kulcs felvétele után visszakapcsolni
    // (az AppMenu-ben is ki van kommentelve a checkPermission('CURRENTACCOUNTPREACCOUNTING'))
    // if (!checkPermission('CURRENTACCOUNTPREACCOUNTING')){
    //     const routes = ['/current-account-pre-accounting'];
    //
    //     if (routes.includes(to.path)) {
    //         return false;
    //     }
    // }

    if (!checkPermission('LEDGER')){
        const routes = ['/transactions'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('LEDGERTRANSCACTIONS')){
        const routes = ['/transactions'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    // TODO: PREACCOUNTING jogosultsági kulcs felvétele után visszakapcsolni
    // (az AppMenu-ben is ki van kommentelve a checkPermission('PREACCOUNTING'))
    // if (!checkPermission('PREACCOUNTING')){
    //     const routes = ['/pre-accounting'];
    //
    //     if (routes.includes(to.path)) {
    //         return false;
    //     }
    // }

    if (!checkPermission('ACCOUNTS')){
        const routes = [
            "/current-account",
            "/write-off-debt/invoices",
            "/storno-summary",
            "/over-summary",
            "/current-account/arrangement",
            "/reports/parameterized-account-report"
        ];

        if (routes.includes(to.path)) {
            return false;
        }

        const names = ['NotoReports'];

        if (names.includes(to.name ?? "")){
            return false;
        }
    }
    if (!checkPermission('ACCOUNTSVIEW')){
        const routes = ['/current-account'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('ACCOUNTWRITEOFFDEBT')){
        const routes = ['/write-off-debt/invoices'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('ACCOUNTSTORNOSUMMARY')){
        const routes = ['/storno-summary'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('ACCOUNTOVERSUMMARY')){
        const routes = ['/over-summary'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('ACCOUNTARRANGEMENT')){
        const routes = ['/current-account/arrangement'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('ACCOUNTPARAMETERIZEDREPORT')){
        const routes = ['/parameterized-account-report'];

        if (routes.includes(to.path)) {
            return false;
        }
    }

    if (!checkPermission('ACTIONLOG')){
        const routes = ['/action-log'];

        if (routes.includes(to.path)) {
            return false;
        }
    }

    if (!checkPermission('SETTINGS')){
        const routes = ['/settings'];

        if (routes.includes(to.path)) {
            return false;
        }
    }

    if (!checkPermission('REPORTS')){
        const routes = ['/reports'];

        if (routes.includes(to.path)) {
            return false;
        }
    }

    if (!checkPermission('FINANCIALREPORTS')){
        const routes = ['/accounting-queries/transaction-items', '/accounting-queries/fullfilment-tolerance-level'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    if (!checkPermission('ACCOUNTINGTRANSACTIONITEMS')) {
        const routes = ['/accounting-queries/transaction-items'];

        if (routes.includes(to.path)) {
            return false;
        }
    } 
    if (!checkPermission('ACCOUNTINGTOLERANCELEVEL')) {
        const routes = ['/accounting-queries/fullfilment-tolerance-level'];

        if (routes.includes(to.path)) {
            return false;
        }
    }

    if (!checkPermission('NEWPARTNER')) {
        const names = ['PartnerCreate'];

        if (names.includes(to.name ?? "")){
            return false;
        }
    }

    if (!checkPermission('CARDPAYMENTS')) {
        const names = ['CardPayments'];

        if (names.includes(to.name ?? "")){
            return false;
        }
    }   
    if (!checkPermission('CASHFLOWRIPORT')) {
        const routes = ['/cashflow-riport'];

        if (routes.includes(to.path)) {
            return false;
        }
    }
    
    return true;
}

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    if (!auth.isLoggedIn && to.name != "Login") {
        next({ name: "Login", query: { redirect: to.fullPath } });
    }
    if (auth.isLoggedIn && auth.passwordChangeRequired && to.name != "ChangePasswordPage") {
        next({ name: "ChangePasswordPage" });
    } else {
        if (checkRouteAccessible(to)){
            next();
        }
    }
});

links.activate.router = router;
export default router;
